const styles = {
  button: {
    padding: 0,
          margin: 0,
          minWidth: 30,
          width: 40,
          height: 48
    },
    icon: {
      verticalAlign: 'initial'
    }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/loaders/styles/ButtonLoaderStyles.js